import { InactivityService } from './services/inactivity.service';
import { Component, OnInit, Renderer2, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { LogoService } from './services/logo.service';
import { ConfigurationService } from './services/configuration.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent implements OnInit {
  title = 'Clinical Suite';

  constructor(private inactivityService: InactivityService,
    private logoService: LogoService,
    private renderer: Renderer2,
    @Inject(DOCUMENT) private document: Document,
    private configurationService: ConfigurationService
  ) {}

  ngOnInit() {
    // a page restored by Back from the browser's back-forward cache would show old data after a logout: reload it,
    // so the route guards check the (cleared) session again
    window.addEventListener('pageshow', (event: PageTransitionEvent) => {
      if (event.persisted) window.location.reload();
    });
    this.setFavicon();
    this.setSpinnerBackground();
    this.applySpinnerClass();
    this.configurationService.loadAppVersion();
  }

  setSpinnerBackground(): void {
    const spinnerLogo = this.logoService.getSpinnerLogoPath();
    this.document.documentElement.style.setProperty('--spinner-logo-url', `url('${spinnerLogo}')`);
  }

  applySpinnerClass(): void {
    const spinnerClass = this.logoService.getSpinnerClass();
    this.renderer.addClass(document.body, spinnerClass);
  }

  setFavicon() {
    const faviconPath = this.logoService.getFaviconPath();
    let link: HTMLLinkElement;
    
    try {
      link = this.renderer.selectRootElement("link[rel*='icon']", true);
    } catch {
      link = this.renderer.createElement('link');
      this.renderer.appendChild(document.head, link);
    }
    
    this.renderer.setAttribute(link, 'type', 'image/x-icon');
    this.renderer.setAttribute(link, 'rel', 'icon');
    this.renderer.setAttribute(link, 'href', faviconPath);
  }
}
